import React from "react";
import { Helmet } from "react-helmet";
import { graphql, StaticQuery } from "gatsby";
import { IMetadata, IMetadataAttribute, ISite } from "../../interfaces";
import { useLocation } from "@reach/router";

// prettier-ignore
interface SeoProps {
  description: string;
  lang: string;
  title: string;
  site: ISite;
  bodyId: string;
}

// prettier-ignore
interface OG {
  property: string;
  content: string;
}

function assembleMetada(metadatas: IMetadata[]) {
  return (metadatas || []).map(({ attribute: attributes }: IMetadata) => {
    const returnObj = {};
    attributes.forEach(({ attribute, value }: IMetadataAttribute) => {
      returnObj[attribute] = value;
    });

    return returnObj;
  });
}

function SEO({ bodyId = "", description = "", lang = "en", title, site }: SeoProps) {
  const { custom_css, metadata, site_name } = { ...site };
  const seo_title = title;
  const seo_description = description;
  const location = useLocation();
  const metadataTotal = [
    {
      name: `viewport`,
      content: "width=device-width, initial-scale=1"
    },
    {
      name: "facebook-domain-verification",
      content: "kqh1kinpv53w8phnmc9q8gzlx8u9bf"
    },
    {
      name: "description",
      content: description
    },
    ...assembleMetada(metadata)
  ];

  return (
    <>
      {/*
      @ts-expect-error Server Component
      */}
      <StaticQuery
        query={graphql`
          query HeadingQuery {
            site {
              siteMetadata {
                siteUrl
                og {
                  type
                  image
                  url
                }
              }
            }
          }
        `}
        render={(data) => {
          const { og, siteUrl } = data.site.siteMetadata;
          const ogMeta: OG[] = [];

          const extendedOg = {
            ...og,
            title: seo_title,
            description: seo_description
          };

          Object.keys(extendedOg).forEach((key) => {
            if (extendedOg[key] && extendedOg[key].length > 0) {
              if (key === "url") {
                ogMeta.push({
                  property: `og:${key}`,
                  content: `${siteUrl}${location.pathname}`
                });
              } else {
                ogMeta.push({
                  property: `og:${key}`,
                  content: extendedOg[key]
                });
              }
            }
          });

          return (
            <Helmet
              bodyAttributes={{
                id: bodyId,
                class: "width-fit"
              }}
              htmlAttributes={{
                lang,
                class: "width-fit"
              }}
              title={title}
              meta={[...ogMeta, ...metadataTotal]}
            >
              <link rel="canonical" href={`${siteUrl}${location.pathname}`} />
              <link
                rel="apple-touch-icon"
                sizes="180x180"
                href={`/images/${site_name}/apple-touch-icon.png`}
              />
              <link
                rel="icon"
                type="image/png"
                sizes="32x32"
                href={`/images/${site_name}/favicon-32x32.png`}
              />
              <link
                rel="icon"
                type="image/png"
                sizes="16x16"
                href={`/images/${site_name}/favicon-16x16.png`}
              />
              <link
                id="favicon"
                rel="icon"
                href={`/images/${site_name}/favicon.ico`}
                type="image/x-icon"
              />
              <style type="text/css">{custom_css}</style>
            </Helmet>
          );
        }}
      />
    </>
  );
}

export default SEO;
